/**
 * Helpers pour gérer les messages bilingues (FR/EN) avec fallback automatique.
 *
 * Un message peut être envoyé en une seule langue. Quand l'utilisateur regarde
 * le message dans une langue qui n'est pas remplie, on doit :
 * - afficher le contenu de l'autre langue (fallback automatique)
 * - signaler à l'utilisateur que le contenu est dans l'autre langue (banner)
 */

/**
 * Détecte si un message a un contenu textuel pour une langue donnée.
 * Vérifie body OU htmlBody (l'un des deux suffit).
 */
export function hasMessageContent(msg, lang) {
    if (!msg) return false;
    const body = lang === 'fr' ? msg.bodyFr : msg.bodyEn;
    const html = lang === 'fr' ? msg.htmlBodyFr : msg.htmlBodyEn;
    return !!(body && body.trim()) || !!(html && html.trim());
}

/**
 * Retourne quel langue est effectivement disponible pour un message,
 * et si la langue souhaitée a dû être remplacée par un fallback.
 *
 * @returns { actualLang: 'fr' | 'en', isFallback: boolean }
 *   - actualLang : la langue effectivement utilisée pour le rendu
 *   - isFallback : true si on affiche l'autre langue par défaut
 *   - returns null if message has no content at all
 */
export function resolveMessageLang(msg, requestedLang) {
    const hasReq = hasMessageContent(msg, requestedLang);
    const otherLang = requestedLang === 'fr' ? 'en' : 'fr';
    const hasOther = hasMessageContent(msg, otherLang);

    if (hasReq) return { actualLang: requestedLang, isFallback: false };
    if (hasOther) return { actualLang: otherLang, isFallback: true };
    return null;
}

/**
 * Texte du bandeau d'avertissement quand on affiche un fallback de langue.
 */
export function getFallbackNoticeText(requestedLang) {
    return requestedLang === 'fr'
        ? "Ce message n'est disponible qu'en anglais — affichage de la version anglaise ci-dessous."
        : 'This message is only available in French — showing the French version below.';
}
